













































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import { GetExamList, GetMoniExam } from "@/request/common";
import Countdown from "@/components/countdown.vue";
import Empty from "@/components/empty.vue";

@Component({
  components: {
    Header,
    LeftNav,
    Countdown,
    Empty,
  },
})
export default class Name extends Vue {
  private data: any = [];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }

  private get user() {
    return this.$store.state.user;
  }
  private goMoni() {
    const params = {
      params: {
        banji_id: this.user["所属班级"].banji_id,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetMoniExam(this, params, loading).then((res: any) => {
      this.$router.push({
        path: "/main/shixun/exam-start",
        query: {
          type: "模拟",
          id: res.exam_id,
        },
      });
    });
  }
  private startExam(item: any) {
    this.$router.push({
      path: "/main/shixun/exam-start",
      query: {
        type: "正式",
        id: item.exam_id,
      },
    });
  }
  private ifStart(time: any) {
    const time1: any = new Date().getTime();
    const time2: any = new Date(time).getTime();
    if (time1 > time2) {
      return true;
    } else {
      return false;
    }
  }
  private goExamList() {
    this.$router.push({
      path: "/main/shixun/exam-list",
    });
  }
  private updata() {
    this.$forceUpdate();
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      banji_id: this.user["所属班级"].banji_id,
      order_key: "开始时间",
      order_value: 0,
      current_page: 1,
      page_count: 0,
    };
    GetExamList(this, params, loading)
      .then((res: any) => {
        this.data = res.data;
        loading.close();
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    this.getData();
  }
}
